<template>
  <div class="ubm">
    <h3 style="padding: 30px 0;">UBM检查</h3>
    <UPfile type="UBM"></UPfile>
    <div class="bz">
      <p>备注：</p>
      <el-input
          type="textarea"
          :autosize="{ minRows: 4, maxRows: 6}"
          placeholder="请输入内容"
          v-model="datas.S_OP_Json.CL_RE_UBM_Remark">
      </el-input>
    </div>
    <div style="padding-top: 15px;text-align: center;"><el-button style="width: 98px" type="primary" @click="save">保存</el-button></div>
  </div>
</template>

<script>
import pf from "@/publicFn/baseFn.js"
export default {
  name: "ubm",
  data() {
    return {
      v1: '',
      datas: {
        S_OP_ChooseId: this.$store.state.physicianVisits.xzConsulting,
        S_OP_ExpertId: this.$store.state.users.user.UserId,
        S_OP_CustomerId: this.$store.state.users.CsUser.CustomerId,
        S_OP_Type: 'CL_RE_UBM',
        S_OP_Model: 'CL_RE_UBM180726',
        S_OP_Json: {
          CL_RE_UBM_Remark: ''
        }
      }
    }
  },
  created() {
    this._http.post(pf.getUrl('PS_all_Normal_getList'), {
      "token": {
        "TimeSpan": 1566827733,
        "sToken": "768DCAFFF869CD61372790C2738012EC"
      },
      SearchCondition: {
        S_OP_Type: 'CL_RE_UBM',
        ChooseId: this.$store.state.physicianVisits.xzConsulting
      }
    })
        .then(res => {
          if (res.GetListResult && res.GetListResult.length) {
            this.datas = JSON.parse(JSON.stringify(res.GetListResult[0]))
            this.datas.S_OP_Json = pf.decoding(this.datas.S_OP_Json)
          }
        })
  },
  methods: {
    save() {
      let log = this.$loading({
        text: '保存中...'
      })
      let obj = JSON.parse(JSON.stringify(this.datas))
      obj.S_OP_Json =  pf.conversionJson(obj.S_OP_Json)
      this._http.post(pf.getUrl('S_ALL_Normal_Save'), {
        "token": {
          "TimeSpan": 1566827733,
          "sToken": "768DCAFFF869CD61372790C2738012EC"
        },
        o: obj
      })
          .then(res => {
            log.close()
            if (res.UpdateResult) {
              this.$store.commit('isbc/uptjk', {
                keys: 'ubm',
                val: true
              })
              this.$alert('保存成功！', '提示')
            }else {
              this.$alert('保存失败请稍后再试！', '提示')
            }
          })
    }
  },
  components: {
    UPfile: () => import('@/components/CommonComponents/upFile')
  }
}
</script>

<style scoped lang="scss">
.ubm {
  padding: 15px 0;
  width: 90%;
  margin: 0 auto;
  text-align: left;
}
.bz {
  padding-top: 30px;
  p{
    padding-bottom: 10px;
  }
}
</style>
